/**
 * @file App.tsx
 * @module App
 * @description Karšu pārlūka saknes (root) komponente. Inicializē i18next
 *              internacionalizāciju ar latviešu (lv) valodu kā noklusējumu.
 *              Apslāpē konsoles brīdinājumus ražošanas vidē. Renderē GlobalSettings
 *              nodrošinātāju, kas inicializē visu kartes lietotni.
 */

import { initReactI18next } from "react-i18next";
import { GlobalSettings } from "./Settings";
import { TRANSLATIONS } from "./shared/translations";
import i18n from "i18next";
import { IS_LOCALHOST } from "./map/Endpoints";

i18n.use(initReactI18next).init({
	resources: TRANSLATIONS,
	lng: "lv",
	fallbackLng: "lv",
	interpolation: {
		escapeValue: false,
	},
});

/** Suppress console warnings in production to reduce noise */
if (!IS_LOCALHOST) console.warn = function filterWarnings(msg, ...args) {};

/**
 * Root application component.
 *
 * Renders the GlobalSettings provider without any preset, showing the full
 * interactive map. For direct-link views, pass name and ids props
 * (e.g., name="unexpectedEvent" ids={["kafka_id_1"]}).
 *
 * @returns {React.ReactElement} The global settings provider wrapping the map
 */
function App() {
	return <GlobalSettings></GlobalSettings>;
}

export default App;
